'use client'
import Script from 'next/script'

const QueueIt = () => {
  return (
    <>
      <Script
        src='https://static.queue-it.net/script/queueclient.min.js'
        strategy='afterInteractive'
        onLoad={() => {
          //console.log('QueueIt Queue client external script loaded successfully!')
        }}
        onError={(e) => {
          console.error('Error loading external script:', e)
        }}
      />
      <Script
        data-queueit-intercept-domain={
          process.env.NEXT_PUBLIC_QUEUEIT_INTERCEPT_DOMAIN
        }
        data-queueit-intercept='true'
        data-queueit-spa='true'
        data-queueit-c='cherrylane'
        src='https:////static.queue-it.net/script/queueconfigloader.min.js'
        strategy='afterInteractive'
        onLoad={() => {
          //console.log('QueueIt Config external script loaded successfully!')
        }}
        onError={(e) => {
          console.error('Error loading external script:', e)
        }}
      />
    </>
  )
}

export default QueueIt
